/* ===== Подключение компонентов React ===== */

/* ===== Подключение локальной Базы Данных ===== */
import HeroCards from "../../../data/cardsDb/heroCards";

/* ===== Подключение локальных компонентов ===== */
import Card from "../../ui/Card/CardsSection";

/* ===== Подключение стилей ===== */
import s from "./Hero.module.scss";


function Hero() {
    return (
        <section className={s.hero}>
            <div className={`container ${s.container}`}>
                <div className={s.titleContainer}>
                    <h1>
                        Дизельное топливо Евро-5 с доставкой<br /> от 500 л по Москве и МО за 24 часа
                    </h1>
                    <h3>
                        Работаем без посредников.<br />
                        Цена фиксируется заранее.<br />
                        Паспорт качества - к каждой партии.
                    </h3>
                </div>
                <div className={s.cardContainer}>
                    <Card {...HeroCards} />
                </div>
            </div>
        </section>
    )
}

export default Hero;